import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

export default function About() {
  return (
    <>
      <Navbar />
      <main className="pt-16 bg-background-950 min-h-screen">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        {/* Hero */}
        <section className="py-10 md:py-16 bg-background-900/30">
          <div className="w-full px-4 md:px-6 text-center max-w-3xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100 mb-4">
              关于七七影院
            </h1>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
              七七影院成立于2024年，是一个致力于为全球华语用户提供高清免费电影与电视剧在线观看服务的平台。我们相信，优质的影视内容应该对所有人开放，观影不应该有门槛。在这里，您可以畅享海量影视资源，无需付费，无需等待，即点即看。
            </p>
          </div>
        </section>

        {/* Mission */}
        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              {[
                {
                  icon: 'ri-eye-line',
                  title: '我们的愿景',
                  desc: '成为华语用户首选的在线观影平台，让每一个人都能轻松享受高品质的影视内容，打破地域与经济的限制，实现真正的观影自由。',
                },
                {
                  icon: 'ri-heart-pulse-line',
                  title: '我们的使命',
                  desc: '持续为用户提供最新、最全、最高清的影视资源，以极致的观影体验和零门槛的服务，让每一位用户都能找到心仪的影视作品。',
                },
                {
                  icon: 'ri-shining-line',
                  title: '核心价值观',
                  desc: '免费无广告是我们的坚持，高清不缓冲是我们的承诺。我们始终将用户体验放在首位，用心做好每一个细节。',
                },
              ].map((item, i) => (
                <div key={i} className="bg-background-800/50 rounded-lg p-6 text-center">
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-500/10 rounded-full">
                    <i className={`${item.icon} text-accent-500 text-2xl`}></i>
                  </div>
                  <h2 className="text-base font-heading font-semibold text-foreground-200 mb-2">{item.title}</h2>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="py-10 md:py-14 bg-background-900/30">
          <div className="w-full px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
              {[
                { value: '10,000+', label: '影视资源' },
                { value: '500万+', label: '月活用户' },
                { value: '99.9%', label: '服务可用率' },
                { value: '24/7', label: '内容更新' },
              ].map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400 mb-1">{stat.value}</div>
                  <div className="text-xs text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6 max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-100 mb-2">联系我们</h2>
              <p className="text-sm text-foreground-500">如有任何问题或建议，欢迎通过以下方式联系我们</p>
            </div>
            <div className="bg-background-800/50 rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {[
                  { icon: 'ri-mail-line', label: '电子邮箱', value: 'contact@77cinema.com' },
                  { icon: 'ri-wechat-line', label: '微信公众号', value: '七七影院' },
                  { icon: 'ri-global-line', label: '官方网站', value: 'www.77cinema.com' },
                  { icon: 'ri-time-line', label: '工作时间', value: '周一至周日 9:00-21:00' },
                ].map((contact, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-accent-500/10 rounded-lg">
                      <i className={`${contact.icon} text-accent-500 text-lg`}></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-600 mb-0.5">{contact.label}</p>
                      <p className="text-sm text-foreground-300 font-medium">{contact.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="py-10 md:py-14 bg-background-900/30">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-100 mb-2">常见问题</h2>
              <p className="text-sm text-foreground-500">关于七七影院的常见疑问解答</p>
            </div>
            <div className="flex flex-col gap-3">
              {[
                { q: '七七影院真的完全免费吗？', a: '是的，我们承诺所有影视资源均可免费观看，不存在任何隐形收费或付费墙。我们通过合理的运营模式维持平台运转，确保用户获得最好的免费观影体验。' },
                { q: '需要注册账号吗？', a: '不需要。七七影院无需注册、无需登录即可观看所有内容。我们尊重您的隐私，不会收集任何不必要的个人信息。' },
                { q: '内容来源合法吗？', a: '我们严格遵守相关法律法规，所有内容均来自正规渠道合作。我们致力于为用户提供安全、合法的观影环境。' },
                { q: '如何反馈问题？', a: '您可以通过上方列出的联系方式与我们取得联系。我们的团队会在24小时内回复您的反馈，认真对待每一条建议和意见。' },
              ].map((faq, i) => (
                <details key={i} className="group bg-background-800/50 rounded-lg overflow-hidden cursor-pointer">
                  <summary className="flex items-center justify-between px-5 py-3 md:py-4 text-sm font-medium text-foreground-200 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '七七影院',
            url: typeof window !== 'undefined' ? window.location.origin : '',
            description: '七七影院提供海量高清免费电影与免费电视剧在线观看服务，画质超清不缓冲，无需付费即点即看。',
            foundingDate: '2024',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              email: 'contact@77cinema.com',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              { '@type': 'Question', name: '七七影院真的完全免费吗？', acceptedAnswer: { '@type': 'Answer', text: '是的，我们承诺所有影视资源均可免费观看，不存在任何隐形收费或付费墙。' } },
              { '@type': 'Question', name: '需要注册账号吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要。七七影院无需注册、无需登录即可观看所有内容。' } },
              { '@type': 'Question', name: '内容来源合法吗？', acceptedAnswer: { '@type': 'Answer', text: '我们严格遵守相关法律法规，所有内容均来自正规渠道合作。' } },
              { '@type': 'Question', name: '如何反馈问题？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过网站列出的联系方式与我们取得联系，团队会在24小时内回复。' } },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: typeof window !== 'undefined' ? window.location.origin + '/' : '' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '关于七七影院 - 品牌介绍与联系方式',
            description: '了解七七影院的品牌故事、核心价值观与联系方式。七七影院致力于提供高清免费电影在线观看服务。',
            url: typeof window !== 'undefined' ? window.location.href : '',
          }),
        }}
      />
    </>
  );
}